module.exports = __webpack_public_path__ + "static/2-0e4eeafb474e3a5c5049695b0ed329ab.jpeg";